declare global {
  interface Window {
    gtag?: (...args: unknown[]) => void
    fbq?: (...args: unknown[]) => void
  }
}

interface TTrusteEU {
  clickListener: () => void
  addEventListener: (listener: (topic: string) => void) => void
  /** ID of the TrustArc overlay element — used by the mutation observer close listener */
  popdiv: string
}

interface TTrusteCMA {
  callApi: <T>(...args: any[]) => T
}

export interface TTruste {
  eu: TTrusteEU
  cma: TTrusteCMA
}

export enum TRUSTE_CONSENT {
  DENIED = 'denied',
  APPROVED = 'approved',
}

export enum TRUSTE_CONSENT_DECISION {
  ALL = 0,
  REQUIRED = 1,
  FUNCTIONAL = 2,
  ADVERTISING = 3,
}

// dataLayer event names pushed by TrustArc (requires "Push CCM events to dataLayer" enabled)
export const TRUSTARC_DATALAYER_EVENT = {
  READY: 'trustarc-ccm-ready',
  CONSENT_UPDATED: 'trustarc-consent-updated',
} as const

export interface TrustArcDataLayerConsent {
  ta_category_1?: boolean // Required
  ta_category_2?: boolean // Functional
  ta_category_3?: boolean // Advertising
}

export interface TrustArcDataLayerEvent {
  event: 'trustarc-ccm-ready' | 'trustarc-consent-updated'
  timestamp: number
  consent: TrustArcDataLayerConsent
  consentModel: 'opt-in' | 'opt-out' | 'none'
}

// DOM CustomEvent dispatched by TrustArc.ts after consent cookies are saved on
// the banner-accept (no-reload) path. Consumed by inject-consent-scripts.ts and
// statsig-consent.hook.ts. Modal/reject paths reload the page instead.
export const QUINCE_CONSENT_EVENT = {
  GRANTED: 'quince:consent-granted',
} as const

export interface QuinceConsentGrantedDetail {
  isFunctional: boolean
  isAdvertising: boolean
}
